import { Component, OnInit } from '@angular/core';
import { SdsFileService } from '../../services/sds-repository-file/sds-file.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';

interface FeedbackType {
  id: number;
  name: string;
}

@Component({
  selector: 'app-feedback-modal',
  templateUrl: './app-feedback-modal-content.component.html',
  styleUrls: ['./app-feedback-modal-content.component.scss'],
})
export class FeedbackModalComponent implements OnInit {
  feedbackForm: FormGroup = new FormGroup({});
  feedbackTypes: FeedbackType[] = [];

  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private dialogService: DialogService,
    private sdsFileService: SdsFileService,
    private dialogRef: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.feedbackForm = this.formBuilder.group({
      feedback_type: ['', [Validators.required, this.validateFeedbackType]],
      feedback_comment: ['', [Validators.required, Validators.maxLength(500)]],
    });
    this.feedbackForm.controls['feedback_type'].setValue(this.feedbackTypes[0]);
    this.feedbackTypes = [
      { id: 0, name: 'Select Feedback Type:' },
      { id: 1, name: 'Feature Request' },
      { id: 2, name: 'Bug Report' },
      { id: 3, name: 'Performance Issue' },
      { id: 4, name: 'Other' },
    ];
  }

  validateFeedbackType(control: AbstractControl) {
    const selectedType = control.value;
    return selectedType && selectedType.id !== 0
      ? null
      : { chooseOption: true };
  }

  submitFeedback() {
    this.loading = true;
    // Get the value of the 'feedback_comment' control from the feedbackForm
    let comments = this.feedbackForm.controls['feedback_comment']?.value;

    // If the 'comments' variable is truthy, remove any HTML tags from it
    if (comments) {
      comments = comments.replace(/(<([^>]+)>)/gi, '');
    }

    // Convert the feedbackForm data to a JSON string, using null as the default value
    const feedback = JSON.stringify({
      feedback_type:
        this.feedbackForm.controls['feedback_type']?.value?.name ?? null,
      feedback_comment: comments ?? null,
    });
    this.sdsFileService.submitFeedback(feedback).subscribe(
      () => {
        this.dialogRef.close();
        this.loading = false;
        Swal.fire({
          position: 'top-end',
          text: 'Feedback submitted successfully!',
          timer: 1000,
          icon: 'success',
          showConfirmButton: false,
        }).then(() => {
          this.dialogRef.close();
        });
      },
      () => {
        this.loading = false;
        this.dialogRef.close();
        Swal.fire({
          position: 'top-end',
          text: 'An issue has occurred while submitting the feedback. Please try again!',
          icon: 'error',
          timer: 1000,
          showConfirmButton: false,
        }).then(() => {
          this.dialogRef.close();
        });
      }
    );
  }
}
